export default function (boolValue) {
  return boolValue ? 'Yes' : 'No'
}
